import L from "leaflet";
import _ from "lodash";
import rgbToHslFilter from "./rgbToHslFilter";

class AssetMapMarkerIcon extends L.Icon.Default {
  constructor(options) {
    if (!_.isNil(options)) {
      options.shadowUrl =
        "https://d78h1pd9y8z1h.cloudfront.net/dashboard/images/transparent.png";
      options.shadowRetinaUrl =
        "https://d78h1pd9y8z1h.cloudfront.net/dashboard/images/transparent.png";
      options.shadowSize = [1, 1];
    }
    super(options);
  }

  initialize(options) {
    options.shadowUrl =
      "https://d78h1pd9y8z1h.cloudfront.net/dashboard/images/transparent.png";
    options.shadowSize = [1, 1];
    options.shadowRetinaUrl =
      "https://d78h1pd9y8z1h.cloudfront.net/dashboard/images/transparent.png";
    L.Icon.Default.prototype.initialize.call(this, options);
  }

  createIcon(oldIcon) {
    const element = super.createIcon(oldIcon);
    if (this.options && this.options.rgbColor) {
      element.style.filter = rgbToHslFilter(this.options.rgbColor)
        .replace("filter: ", "")
        .replace(";", "");
      element.style.opacity = this.options.opacity.toString();
    }

    return element;
  }

  createShadow(oldIcon) {
    const element = super.createShadow(oldIcon);
    element.src = this.options.shadowUrl;
    return element;
  }

  // noinspection JSMethodCanBeStatic,JSUnusedGlobalSymbols,JSUnusedLocalSymbols
  _getIconUrl(name) {
    return "https://d78h1pd9y8z1h.cloudfront.net/dashboard/images/marker-icon-black-v2f.png";
  }
}

export { AssetMapMarkerIcon as MarkerIcon };
